import { createSelector } from 'reselect';
import { b64ToBlob } from '../components/Common/imageCompressor';

const proveedoresReducerDataSelector = state => state.proveedoresReducer.getIn(["data"]).toJS();

export const proveedoresDataSelector = createSelector(
    proveedoresReducerDataSelector, (dataField) => {
        return {
            proveedores: (dataField.proveedores && dataField.proveedores.map) ? dataField.proveedores.map(x => ({ ...x, imagen: b64ToBlob(x.imagen) })) : dataField.proveedores
        };
    }
);

export const proveedoresEditSelector = createSelector(
    proveedoresReducerDataSelector, (dataField) => {
        return {
            proveedor: {
                ...dataField.proveedorEdit,
                imagen: (dataField.proveedorEdit) && b64ToBlob(dataField.proveedorEdit.imagen),
                imagenOriginal: (dataField.proveedorEdit) && b64ToBlob(dataField.proveedorEdit.imagenOriginal)
            }
        };
    }
);